import { combineReducers } from "redux";

import agentsReducer from "./slices/support-agents";

import authReducer from "./slices/auth";
import centralEmailThreadsReducer from "./slices/central-email-threads";
import currentUserReducer from "./slices/current-user";
import internalChatbotReducer from "./slices/internal-chatbot";
import supplierPhoneCallsReducer from "./slices/supplier-phone-calls";
import ticketReducer from "./slices/ticket";
import ticketsReducer from "./slices/tickets";

const rootReducer = combineReducers({
  agents: agentsReducer,

  auth: authReducer,
  centralEmailThreads: centralEmailThreadsReducer,
  currentUser: currentUserReducer,
  internalChat: internalChatbotReducer,
  supplierPhoneCalls: supplierPhoneCallsReducer,
  ticket: ticketReducer,
  tickets: ticketsReducer,
});

export default rootReducer;
